"use strict";
exports.__esModule = true;
exports.PageType = void 0;
var PageType;
(function (PageType) {
    PageType["COLD_ARTICLE"] = "cold_article";
    PageType["FINANCIAL_DEBT"] = "financial_debt";
    PageType["FINANCIAL_KEY_FIGURES"] = "financial_key_figures";
    PageType["FINANCIAL_PRESS_RELEASE"] = "financial_press_release";
    PageType["FINANCIAL_PUBLICATION"] = "financial_publication";
    PageType["FINANCIAL_RATING"] = "financial_rating";
    PageType["HOME"] = "home";
    PageType["HOT_ARTICLE"] = "hot_article";
    PageType["HUB_ACTUS"] = "hub_actus";
    PageType["HUB_NEWSROOM"] = "hub_newsroom";
    PageType["LA_POSTE_EN_4"] = "la_poste_en_4";
    PageType["MEDIA_POPIN"] = "media_popin";
    PageType["MEDIA_PRESS"] = "media_presse";
    PageType["MEDIA_PRESS_RELEASE"] = "media_presse_release";
    PageType["NEWSROOM"] = "newsroom";
    PageType["RSE"] = "rse";
    PageType["SEARCH"] = "search_page";
    PageType["SLIDER_POPIN"] = "slider_popin";
    PageType["TIMELINE_POPIN"] = "timeline_popin";
})(PageType = exports.PageType || (exports.PageType = {}));
//# sourceMappingURL=page-type.js.map